import { TokensColors } from '@modules/VanOord.Styleguide/Frontend/content/tokens/colors.sg'
import { TokensIcons } from '@modules/VanOord.Styleguide/Frontend/content/tokens/icons.sg'
import {
  TokensFonts,
  TokensStyles,
  TokensTypography
} from '@modules/VanOord.Styleguide/Frontend/content/tokens/typography.sg'
import * as React from 'react'
import { Widget, any, fromJSX } from 'widgets-for-react'
import { styleguideChapter, styleguideSection, styleguideTokenPart, styleguideTokenRow } from '../helpers.mod'

export const styleguideTokens: Widget<never> = styleguideChapter(
    {
      type: 'tokens',
      slug: 'tokens',
      title: 'Design Tokens',
      intro:
        'Design tokens are the visual design atoms of the design system — specifically, they are named entities that store visual design attributes. We use them in place of hard-coded values (such as hex values for color or pixel values for spacing) in order to maintain a scalable and consistent visual system for UI development.'
    })(
      any([
        styleguideSection({
          type: 'tokens',
          slug: 'tokens-colors',
          title: 'Colors',
          intro: 'Please refer to the description of each token for their intended usage.'
        })(fromJSX(() => <TokensColors />)),
        styleguideSection({ type: 'tokens', slug: 'tokens-fonts', title: 'Fonts', intro: '' })(
          fromJSX(() => <TokensFonts />)
        ),
        styleguideSection({ type: 'tokens', slug: 'tokens-styles', title: 'Font Styles', intro: '' })(
          fromJSX(() => <TokensStyles />)
        ),
        styleguideSection({
          type: 'tokens',
          slug: 'tokens-sizes-heights',
          title: 'Font Sizes & Line Heights',
          intro: ''
        })(fromJSX(() => <TokensTypography />)),
        styleguideSection({ type: 'tokens', slug: 'tokens-icons', title: 'Icons', intro: '' })(
          fromJSX(() => <TokensIcons />)
        ),
        styleguideSection({ type: 'tokens', slug: 'tokens-transitions', title: 'Transitions', intro: '' })(
          styleguideTokenPart({ hasExampleColumn: false, hasAttributeColumn: true })(
            any([
              styleguideTokenRow({
                code: 'transition(1)',
                description: '',
                attributes: '0.3 seconds',
                columnCount: 2,
                hasSeparator: false,
                hasExample: false
              })(fromJSX(() => null))
            ])
          )
        )
      ])
    ).never()
